var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_376_5102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 20,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16411 7.26353C7.16411 8.41407 6.26872 9.34678 5.16419 9.34678C4.05966 9.34678 3.16427 8.41407 3.16427 7.26353C3.16427 6.11298 4.05966 5.18028 5.16419 5.18028C6.26872 5.18028 7.16411 6.11298 7.16411 7.26353Z",
    fill: "#B4DBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000488281 3.75024C0.000488281 2.59969 0.895884 1.66699 2.00041 1.66699H17.9998C19.1043 1.66699 19.9997 2.59969 19.9997 3.75024V16.2497C19.9997 17.4003 19.1043 18.333 17.9998 18.333H16.6797C16.6753 18.333 16.6709 18.333 16.6665 18.333H2.45621C2.45244 18.333 2.44868 18.333 2.44491 18.333H2.00041C0.895884 18.333 0.000488281 17.4003 0.000488281 16.2497V3.75024ZM2.00041 3.22943H17.9998C18.2759 3.22943 18.4998 3.4626 18.4998 3.75024V10.2418L14.1547 5.83351L6.7624 13.3332L4.58483 11.124L1.50043 14.2532V3.75024C1.50043 3.4626 1.72428 3.22943 2.00041 3.22943Z",
    fill: "#B4DBFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_376_5102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000488281,
    y: -0.000488281,
    width: 19.9992,
    height: 19.9992,
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.588335b0c8a716c96c80d58c962c7142.svg";
export { ForwardRef as ReactComponent };